const STORAGE = {
  LOCAL: "local",
  SESSION: "session",
};

export const localstorageKeys = {
  sentAt: `${STORAGE.LOCAL}::sentAt`,
  session: `${STORAGE.LOCAL}::session`,
  twitchAccess: `${STORAGE.LOCAL}::twitch`,
  keysVersion: `${STORAGE.LOCAL}::keysVersion`,
  fbAccess: `${STORAGE.LOCAL}::facebook`,
  bannerClosed: `${STORAGE.LOCAL}::bannerClosed`,
  referral: `${STORAGE.SESSION}::referral`,
  trackingCode: `${STORAGE.SESSION}::trackingCode`,
  creatorReferral: `${STORAGE.SESSION}::creatorReferral`,
  tourFinished: `${STORAGE.LOCAL}::tourFinished`,
  authSession: `${STORAGE.LOCAL}::authSession`,
  theme: `${STORAGE.LOCAL}::theme`,
  destination: `${STORAGE.LOCAL}::destination`,
  necessaryCookies: `${STORAGE.LOCAL}::necessaryCookies`,
  marketingCookies: `${STORAGE.LOCAL}::marketingCookies`,
  functionalCookies: `${STORAGE.LOCAL}::functionalCookies`,
  contentRequestOrderType: `${STORAGE.LOCAL}::contentRequestOrderType`,
  contentRequestUsername: `${STORAGE.LOCAL}::contentRequestUsername`,
  shouldSkipLeaveStream: `${STORAGE.LOCAL}::shouldSkipLeaveStream`,
  mutedModalShowed: `${STORAGE.LOCAL}::mutedModalShowed`,
};

export const KeepForever = [
  {
    key: localstorageKeys.bannerClosed,
    defaultValue: false,
  },
  {
    key: localstorageKeys.destination,
    defaultValue: "",
  },
  {
    key: localstorageKeys.referral,
    defaultValue: null,
  },
  {
    key: localstorageKeys.theme,
    defaultValue: "",
  },
  {
    key: localstorageKeys.marketingCookies,
    defaultValue: false,
  },
  {
    key: localstorageKeys.necessaryCookies,
    defaultValue: false,
  },
  {
    key: localstorageKeys.functionalCookies,
    defaultValue: false,
  },
];
